module.exports = __webpack_public_path__ + "static/media/image-minus.3b5c0906.svg";